import { baseApiClient } from "data/modules/api/api.client";
import { getDeviceDetails } from "features/Common/utils/device.utils";
import { SAVE_FCM_TOKEN } from "features/Firebase/constants/Firebase.api";

export const saveFCMToken = (fcmToken) => {
  const { os, osVersion, userAgent } = getDeviceDetails();

  return baseApiClient.post(SAVE_FCM_TOKEN, {
    fcm_token: fcmToken,
    operating_system: os,
    operating_system_version: osVersion,
    user_agent: userAgent,
  });
};
